import { render, staticRenderFns } from "./generic_notices.vue?vue&type=template&id=6cbe873c&scoped=true"
import script from "./generic_notices.vue?vue&type=script&lang=js"
export * from "./generic_notices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbe873c",
  null
  
)

export default component.exports